import Cookies from 'js-cookie';
import {DEFAULT_COOKIE_EXPIRATION_IN_DAYS} from '#api/services/user/userConsts';
import {getCrossSubdomainCookieDomain} from './cookieHelpers';

/**
 * @typedef {import('#api/services/cookie/upRefCookieService').UpRefCookieData} UpRefCookieData
 */

const UP_REF_COOKIE_NAME = 'upref',

      LOCALE_SOURCE = {
	      'GEO' : 'geo',
	      'USER': 'user'
      },

      /**
       * @param {unknown} upRefCookie
       * @returns {boolean}
       */
      isValidUpRefCookieValue = (upRefCookie) => (
	      !!upRefCookie &&
	      typeof upRefCookie === 'object' &&
	      typeof upRefCookie.uid === 'string' &&
	      Array.isArray(upRefCookie.t)
      ),
      
      /** @returns {string} */
      generateUuid = () => (
	      'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replaceAll(/[xy]/g, (char) => {
		      const rnd = Math.floor(Math.random() * 16),
		            val = char === 'x' ? rnd : 8 + Math.floor(rnd / 4);
			  
		      return val.toString(16);
	      })
      ),
      
      /** @returns {string} */
      createUid = () => {
	      if (window.crypto?.randomUUID) {
		      return window.crypto.randomUUID();
	      }
	      
	      return generateUuid();
      },
      
      /** @returns {UpRefCookieData} */
      createInitialUpRefCookieData = () => (
	      {
		      'uid': createUid(),
		      't'  : []
	      }
      ),
      
      /**
       * @param {UpRefCookieData} upRefCookieData
       */
      setUpRefCookie = (upRefCookieData) => {
	      Cookies.set(
		      UP_REF_COOKIE_NAME,
		      JSON.stringify(upRefCookieData),
		      {
			      'domain'  : getCrossSubdomainCookieDomain(),
			      'secure'  : window.location.protocol === 'https:',
			      'expires' : DEFAULT_COOKIE_EXPIRATION_IN_DAYS,
			      'path'    : '/',
			      'sameSite': 'Lax'
		      }
	      );
      },
      
      /**
       * @returns {UpRefCookieData}
       */
      getValidUpRefCookie = () => {
	      let upRefCookie;
	      
	      try {
		      upRefCookie = JSON.parse(
			      Cookies.get(UP_REF_COOKIE_NAME)
		      );
	      } catch (err) {
		      console.error('Invalid upref cookie', err);
	      }
	      
	      if (isValidUpRefCookieValue(upRefCookie)) {
		      return upRefCookie;
	      }
	      
	      upRefCookie = createInitialUpRefCookieData();
	      setUpRefCookie(upRefCookie);
	      
	      return upRefCookie;
      },
      /** @returns {string} */
      getUpRefUid = () => (
	      getValidUpRefCookie().uid
      ),

      /**
       * @param {Partial<UpRefCookieData>} partialData
       */
      updateUpRefCookieData = (partialData) => {
	      const upRefCookie = getValidUpRefCookie();

	      setUpRefCookie({
		      ...upRefCookie,
		      ...partialData
	      });
      };

export {
	LOCALE_SOURCE,
	getValidUpRefCookie,
	getUpRefUid,
	setUpRefCookie,
	updateUpRefCookieData
};